import { ApolloLink, Observable } from '@apollo/client';
import { AUTH_ME } from '@/graphql/query.graphql';
import { cache } from '../cache';
import { memberBlockedSchemas } from '../constants';
import { authMeQuery } from '@/types/generated/graphql';

function isMemberRole(data: authMeQuery | null | undefined) {
  return data?.authMe?.data?.userWorkspaceRole?.[0]?.role?.slug === 'member';
}

export const memberRoleLink = new ApolloLink((operation, forward) => {
  // FORWARD NON-BLOCKED APIS IMMEDIATELY
  if (!memberBlockedSchemas.includes(operation.operationName)) {
    return forward(operation);
  }

  // CHECK USER ROLE FOR BLOCKED APIS
  const authMeCached: authMeQuery | null = cache.readQuery({ query: AUTH_ME });

  if (authMeCached !== null) {
    return isMemberRole(authMeCached) ? null : forward(operation);
  }

  // DETECT USER ROLE CHANGE AND DO VERIFICATION
  return new Observable((observer) => {
    const unwatch = cache.watch<authMeQuery>({
      query: AUTH_ME,
      optimistic: false,
      immediate: true,
      callback({ complete, result }) {
        if (!complete) return;
        unwatch();
        if (isMemberRole(result)) {
          observer.complete();
          return;
        }
        forward(operation).subscribe(observer);
      },
    });
  });
});
